import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  NatConfiguration,
  API_PATH_NAT_CONFIGURATION,
} from './natConfiguration.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getNatConfigurationList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<NatConfiguration>> {
  return http.get(`${API_PATH_NAT_CONFIGURATION}/${deliveryFunctionId}`);
}

export function getNatConfiguration(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<NatConfiguration>> {
  return http.get(`${API_PATH_NAT_CONFIGURATION}/${deliveryFunctionId}/${id}`);
}

export function createNatConfiguration(
  deliveryFunctionId: string,
  body: WithAuditDetails<NatConfiguration>,
): AxiosPromise<ServerResponse<NatConfiguration>> {
  return http.post(`${API_PATH_NAT_CONFIGURATION}/${deliveryFunctionId}`, body);
}

export function updateNatConfiguration(
  deliveryFunctionId: string,
  body: WithAuditDetails<NatConfiguration>,
  id: string,
): AxiosPromise<ServerResponse<NatConfiguration>> {
  return http.put(`${API_PATH_NAT_CONFIGURATION}/${deliveryFunctionId}/${id}`, body);
}

export function deleteNatConfiguration(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<NatConfiguration>> {
  return http.delete(`${API_PATH_NAT_CONFIGURATION}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
